import React, { useEffect, useState } from 'react';
import { G, styles, api } from '../theme.js';
import { Btn, Input, Spinner } from '../ui.jsx';

// Public agreement / contract signing page. URL: /document/:id?t=<token>
export function DocumentSign() {
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(null);
  const [signature, setSignature] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const segs = window.location.pathname.split('/').filter(Boolean);
  const id = segs[1];

  useEffect(() => {
    if (!id) { setErr('Invalid link'); return; }
    api(`/api/portal/documents/${id}`).then(setDoc).catch(e => setErr(e.message));
  }, [id]);

  const sign = async () => {
    if (!signature.trim()) return setErr('Type your full name to sign.');
    setBusy(true);
    try {
      await api(`/api/portal/documents/${id}/sign`, { method:'POST', body:{ signature: signature.trim() } });
      setDone(true);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  if (err) return <div style={page}><div style={{ ...styles.card, padding:30, textAlign:'center', maxWidth:480 }}><h2>Can't open</h2><p style={{ color:G.textMuted }}>{err}</p></div></div>;
  if (!doc) return <div style={page}><Spinner sz={36}/></div>;

  if (done || doc.status === 'signed') return <div style={page}><div style={{ ...styles.card, padding:30, textAlign:'center', maxWidth:480 }}>
    <h2 style={{ color:G.green, margin:0 }}>✓ Signed</h2>
    <p style={{ color:G.textMuted, marginTop:8 }}>Thanks. A copy has been emailed to you and {doc.business?.name} has been notified.</p>
  </div></div>;

  return <div style={page}>
    <div style={{ ...styles.card, padding:30, maxWidth:820, width:'100%' }}>
      <div style={{ fontSize:11, fontWeight:700, color:G.textMuted, textTransform:'uppercase', letterSpacing:'.08em' }}>{doc.business?.name}</div>
      <h2 style={{ margin:'4px 0' }}>{doc.title}</h2>
      <div style={{ color:G.textMuted, fontSize:13 }}>{doc.type?.charAt(0).toUpperCase()+doc.type?.slice(1)} · Please review and sign at the bottom.</div>

      <div style={{ marginTop:22, padding:22, borderTop:`1px solid ${G.border}`, borderBottom:`1px solid ${G.border}`, fontSize:14, lineHeight:1.65, whiteSpace:'pre-wrap', maxHeight:480, overflow:'auto', background:G.input, borderRadius:8 }}>
        {doc.content}
      </div>

      <div style={{ marginTop:22 }}>
        <div style={{ fontSize:12, color:G.textMuted, marginBottom:6 }}>Type your full name to sign:</div>
        <Input value={signature} onChange={e=>setSignature(e.target.value)} placeholder="Your full name" style={{ fontSize:18, fontFamily:'cursive', padding:'10px 14px' }}/>
      </div>

      <Btn v="primary" sz="lg" full disabled={busy} onClick={sign} style={{ marginTop:18 }}>
        {busy ? <Spinner/> : `Sign as "${signature || '...'}"`}
      </Btn>

      <div style={{ marginTop:18, fontSize:11, color:G.textDim, textAlign:'center' }}>
        By signing you agree this electronic signature is legally binding. Powered by TradeOps.
      </div>
    </div>
  </div>;
}

const page = { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:G.bg };
